  <template>
    <div>
    </div>
    </template>
<script>
import axios from '../../../../plugins/axios'
import Swal from 'sweetalert2'
import utilitarios from '../../../../plugins/utilitarios'
import impressaoUtilitario from '../../../../utilitarios/impressao.utilitario'
const FileDownload = require('js-file-download')

const ls = require('local-storage')
export default {
  data: () => ({
    configuracoesReport: ls.get('configuracoesReport'),
    dados: [],
    nameFile: '',
    totais: {
            totalgeralbata10: 0,
            totalgeralbata11: 0,
            totalgeralbata12: 0,
            totalgeralbata13: 0,          
            totalgeralcartao10: 0,
            totalgeralcartao11: 0,
            totalgeralcartao12: 0,
            totalgeralcartao13: 0,
            totalgeralbata: 0,
            totalgeralcartao: 0,
            totalgeraluniformes: 0,
            totalgeralcartoes: 0
  },
    confMat: [{ descricao: '', idCurso: 0, quantMaxTurmas: 0, turmas: [{ turma10: '', qtd10: 0, capacidade10: 0, vagadisponivel10: 0, turma11: '', qtd11: 0, capacidade11: 0, vagadisponivel11: 0, turma12: '', qtd12: 0, capacidade12: 0, vagadisponivel12: 0, turma13: '', qtd13: 0, capacidade13: 0, vagadisponivel13: 0 }] }]
  }),
  computed: {
  },
  watch: {
  },
  created  () {
    this.nameFile = 'Financeiro-' + this.$store.state.anolectivoSelecionado.descricao
    this.carregarDados()
  },
  methods: {
    async frame () {
      try {
        let ficheiro = this.nameFile + '' + this.$store.state.tipoimpressao.sufixo
        await axios({
          url: 'http://localhost:8085/' + 'readfile/' + ficheiro,
          method: 'GET',
          responseType: 'blob' // Important
        }).then(function (response) {
          // @ts-ignore
          // FileDownload(response.data, ficheiro)
          impressaoUtilitario.frameByName('http://localhost:8085/',ficheiro)
        })
        this.sair()
      } catch (error) {
         Swal.fire({
          icon: 'warning',
          title: '',
          text: 'Ficheiro não encontrado'
        })
        this.sair()
      }
    },
    async carregarDados () {
      try {
        this.dados = await axios
          .get('/estatisticafinanca/' + this.$store.state.anolectivoSelecionado.descricao)
          .then(res => res.data)
        for (let i = 0; i < this.dados.length; i++) {
          let maxValue = 0
          const element = this.dados[i]
          if (element.alunos10.length >= element.alunos11.length && element.alunos10.length >= element.alunos12.length && element.alunos10.length >= element.alunos13.length) {
            maxValue = element.alunos10.length
          } else
          if (element.alunos11.length >= element.alunos10.length && element.alunos11.length >= element.alunos12.length && element.alunos11.length >= element.alunos13.length) {
            maxValue = element.alunos11.length
          } else
          if (element.alunos12.length >= element.alunos10.length && element.alunos12.length >= element.alunos11.length && element.alunos12.length >= element.alunos13.length) {
            maxValue = element.alunos12.length
          } else
          if (element.alunos13.length >= element.alunos10.length && element.alunos13.length >= element.alunos11.length && element.alunos13.length >= element.alunos12.length) {
            maxValue = element.alunos13.length
          }
          // @ts-ignore
          this.dados[i].quantMaxTurmas = maxValue
          // @ts-ignore
          /** this.dados[i].total = { turmas10: element.alunos10.length,
            alunos10: this.sum10(element.alunos10),
            turmas11: element.alunos11.length,
            alunos11: this.sum11(element.alunos11),
            turmas12: element.alunos12.length,
            alunos12: this.sum12(element.alunos12),
            turmas13: element.alunos13.length,
            alunos13: this.sum13(element.alunos13)
          } */
        }
        this.comporArrayObject()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar os dados'
        })
      }
    },

    comporArrayObject () {
      try {
        for (let i = 0; i < this.dados.length; i++) {
          const element = this.dados[i]
          
            
          
          // @ts-ignore
          const qtditeracao = this.dados[i].quantMaxTurmas
          for (let j = 0; j < qtditeracao; j++) {
            const alunos10 = (element.alunos10.length > j) ? element.alunos10[j] : { turma: '', alunos: 0, qtdBata: 0, qtdCartao: 0, subtotalBata: 0, subtotalCartao: 0 }
            const alunos11 = (element.alunos11.length > j) ? element.alunos11[j] : { turma: '', alunos: 0, qtdBata: 0, qtdCartao: 0, subtotalBata: 0, subtotalCartao: 0 }
            const alunos12 = (element.alunos12.length > j) ? element.alunos12[j] : { turma: '', alunos: 0, qtdBata: 0, qtdCartao: 0, subtotalBata: 0, subtotalCartao: 0 }
            const alunos13 = (element.alunos13.length > j) ? element.alunos13[j] : { turma: '', alunos: 0, qtdBata: 0, qtdCartao: 0, subtotalBata: 0, subtotalCartao: 0 }
            
            this.dados[i].batasubtotal10 += parseInt(alunos10.qtdBata)
            this.dados[i].batasubtotal11 += parseInt(alunos11.qtdBata)
            this.dados[i].batasubtotal12 += parseInt(alunos12.qtdBata)
            this.dados[i].batasubtotal13 += parseInt(alunos13.qtdBata)


            this.dados[i].cartaosubtotal10 += parseInt(alunos10.qtdCartao)
            this.dados[i].cartaosubtotal11 += parseInt(alunos11.qtdCartao)
            this.dados[i].cartaosubtotal12 += parseInt(alunos12.qtdCartao)
            this.dados[i].cartaosubtotal13 += parseInt(alunos13.qtdCartao)

            this.dados[i].batasubtotalgeral += (parseFloat(alunos10.subtotalBata) + parseFloat(alunos11.subtotalBata) + parseFloat(alunos12.subtotalBata) + parseFloat(alunos13.subtotalBata))
            this.dados[i].cardsubtotalgeral += (parseFloat(alunos10.subtotalCartao) + parseFloat(alunos11.subtotalCartao) + parseFloat(alunos12.subtotalCartao) + parseFloat(alunos13.subtotalCartao))
            
           this.totais.totalgeralbata10 += parseInt(alunos10.qtdBata)
           this.totais.totalgeralbata11 += parseInt(alunos11.qtdBata)
           this.totais.totalgeralbata12 += parseInt(alunos12.qtdBata)
           this.totais.totalgeralbata13 += parseInt(alunos13.qtdBata)
          
           this.totais.totalgeralcartao10 += parseInt(alunos10.qtdCartao)
           this.totais.totalgeralcartao11 += parseInt(alunos11.qtdCartao)
           this.totais.totalgeralcartao12 += parseInt(alunos12.qtdCartao)
           this.totais.totalgeralcartao13 += parseInt(alunos13.qtdCartao)

           this.totais.totalgeraluniformes += (parseFloat(alunos10.subtotalBata) + parseFloat(alunos11.subtotalBata) + parseFloat(alunos12.subtotalBata) + parseFloat(alunos13.subtotalBata)) 
           this.totais.totalgeralcartoes   += (parseFloat(alunos10.subtotalCartao) + parseFloat(alunos11.subtotalCartao) + parseFloat(alunos12.subtotalCartao) + parseFloat(alunos13.subtotalCartao))
            
            // @ts-ignore
            this.dados[i].turmas.push({
                turma10: alunos10.turma,
                qtdbata10: alunos10.qtdBata,
                qtdcard10: alunos10.qtdCartao,
                turma11: alunos11.turma,
                qtdbata11: alunos11.qtdBata,
                qtdcard11: alunos11.qtdCartao,
                turma12: alunos12.turma,
                qtdbata12: alunos12.qtdBata,
                qtdcard12: alunos12.qtdCartao,
                turma13: alunos13.turma,
                qtdbata13: alunos13.qtdBata,
                qtdcard13: alunos13.qtdCartao,
                subtotalBata: utilitarios.IntegerToMoneyValueFatura(parseFloat(alunos10.subtotalBata) + parseFloat(alunos11.subtotalBata) + parseFloat(alunos12.subtotalBata) + parseFloat(alunos13.subtotalBata)),
                subtotalCard: utilitarios.IntegerToMoneyValueFatura(parseFloat(alunos10.subtotalCartao) + parseFloat(alunos11.subtotalCartao) + parseFloat(alunos12.subtotalCartao) + parseFloat(alunos13.subtotalCartao)),
              })
          }
        }
         this.totais.totalgeralbata   += (this.totais.totalgeralbata10+this.totais.totalgeralbata11+this.totais.totalgeralbata12+this.totais.totalgeralbata13)
         this.totais.totalgeralcartao += (this.totais.totalgeralcartao10+this.totais.totalgeralcartao11+this.totais.totalgeralcartao12+this.totais.totalgeralcartao13)

          this.totais.totalgeraluniformes = utilitarios.IntegerToMoneyValueFatura(this.totais.totalgeraluniformes)  
          this.totais.totalgeralcartoes   = utilitarios.IntegerToMoneyValueFatura(this.totais.totalgeralcartoes)  
          
        this.criarRelatorio()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor os dados'
        })
      }
    },
    async criarRelatorio () {
      try {
        await axios({
          method: 'post',
          url: 'http://localhost:8085/' + 'createReport',
          data: {
            totais: this.totais,
            estatistica: this.dados,
            totalcard: 0,
            totaluniforme: 0,
            datacorrente: '',
            subdirectorAdministrativo: '',
            instituicao: ls.get('empresa').toUpperCase(),
            anolectivo: this.$store.state.anolectivoSelecionado.novadescricao,
            namefile: this.nameFile
          }
        }).then((res) => res.data)
        setTimeout(() => {
          this.frame()
        }, 6000)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao criar o documento'
        })
      }
    },
    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.estatistica = false
    },
    sum10 (array) {
      try {
        let somatorio = 0
        if (array.length === 0) return 0
        else {
          array.forEach(element => {
            somatorio += parseInt(element.alunos)
          })
        }
        return somatorio
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    sum11 (array) {
      try {
        let somatorio = 0
        if (array.length === 0) return 0
        else {
          array.forEach(element => {
            somatorio += parseInt(element.alunos)
          })
        }
        return somatorio
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    sum12 (array) {
      try {
        let somatorio = 0
        if (array.length === 0) return 0
        else {
          array.forEach(element => {
            somatorio += parseInt(element.alunos)
          })
        }
        return somatorio
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    sum13 (array) {
      try {
        let somatorio = 0
        if (array.length === 0) return 0
        else {
          array.forEach(element => {
            somatorio += parseInt(element.alunos)
          })
        }
        return somatorio
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    }
  }
}

</script>
